import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "../Generic/Button";
import { errorNotification } from "../Generic/Notifications";
import { AppRoutes, DashboardModules } from "../config/app.config";
import { OfferFormMode, OfferStatus } from "./constants";
import OfferFormWizard from "./Components/OfferFormWizard";
import { useOfferContext } from "./context/OfferContext";
import OffersService from "./Services/OffersService";
import { mapOfferDraftToPayload } from "./utils/offerApiMapping";

const OFFERS_ROUTES = AppRoutes[DashboardModules.OFFERS];

const OfferCreate = () => {
	const navigate = useNavigate();
	const { createOfferDraft, updateCreateOfferDraft, resetCreateOfferDraft, clearOffersList } = useOfferContext();
	const [submitting, setSubmitting] = useState(false);

	async function submitOffer() {
		setSubmitting(true);
		try {
			const payload = mapOfferDraftToPayload(createOfferDraft, OfferStatus.DRAFT);
			const { data, error } = await OffersService.createOffer(payload);
			if (error) {
				errorNotification(error);
				return;
			}
			clearOffersList();
			if (data?._id) {
				navigate(OFFERS_ROUTES.DETAILS.getPath(data._id), { replace: true });
			} else {
				navigate(OFFERS_ROUTES.LIST.getPath(), { replace: true });
			}
			resetCreateOfferDraft();
		} catch {
			errorNotification("Failed to create offer");
		} finally {
			setSubmitting(false);
		}
	}

	return (
		<OfferFormWizard
			title="Create Offer"
			submitLabel="Create Offer"
			headerExtra={
				<Button onClick={() => navigate(OFFERS_ROUTES.GROUP_CREATE.getPath())}>
					Create Offer Group
				</Button>
			}
			draft={createOfferDraft}
			mode={OfferFormMode.CREATE}
			onDraftChange={updateCreateOfferDraft}
			onSubmit={submitOffer}
			onCancel={() => navigate(OFFERS_ROUTES.LIST.getPath())}
			submitting={submitting}
		/>
	);
};

export default OfferCreate;
